import React, { useState } from "react";

import axios from "axios";

import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import logo from "../Assets/Logo.png";
import {
  useDispatch, useSelector
} from "react-redux";
import { getAuth } from "../Store/Features/Auth/AuthSlice";
import { ToastContainer } from 'react-toastify';
import { Button } from "@mui/material";


export const Login = () => {
  const dispatch = useDispatch();

  // React States
  const [errorMessages, setErrorMessages] = useState({});

  const navigate = useNavigate();

  // User Login info



  const handleSubmit = (event) => {
    event.preventDefault();

    var { uname, pass } = document.forms[0];

    if (uname && pass) {
      dispatch(getAuth({
        email: uname.value,
        password: pass.value
      })).then(() => {
        navigate('/');
      });
      // axios.post("https://rawosapi.gitwork-team.com/api/v1/login", {

      // }).then((res) => {
      //   setLoading(false);
      //   localStorage.setItem("authed", res.data.access_token);
      //   localStorage.setItem("role", res.data.data.user.roles[0].title);
      //   navigate('/');
      // }).catch((err) => {

      //   setLoading(false);
      //   setErrorMessages({
      //     message: err.response.data.message
      //   });

      // });
    }

  };

  // Generate JSX code for error message


  // JSX code for login form
  const renderForm = (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container">
          <label >Email</label>
          <input type="text" className="loginField" name="uname" required />

        </div>
        <div className="input-container">
          <label>Password</label>
          <input type="password" className="loginField" name="pass" required />
          {errorMessages.message ? <div className="error">{errorMessages.message}</div> : null}
        </div>
        <div className="button-container">
          <input type="submit" className="loginbtn" label="Login" value="Login" />
        </div>
      </form>
    </div>
  );

  return (
    <div className="app">
      <img className="LoginPageLogo" src={logo} />
      <div className="login-form width-100 height-100">
        <div className="title">Sign In</div>
        {renderForm}
      </div>
      <ToastContainer />
    </div>
  );
}

